import { render, staticRenderFns } from "./VotingsMandateRepresentant.vue?vue&type=template&id=9f0444c8&"
import script from "./VotingsMandateRepresentant.vue?vue&type=script&lang=js&"
export * from "./VotingsMandateRepresentant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports